export const UI_CONFIRMED_TERMSHEET_DISCLAIMER = 'UI_CONFIRMED_TERMSHEET_DISCLAIMER' as const;
export const UI_CONFIRMED_KID_DOCUMENTATION = 'UI_CONFIRMED_KID_DOCUMENTATION' as const;
export const UI_CONFIRMED_FRENCH_PUBLIC_OFFERING = 'UI_CONFIRMED_FRENCH_PUBLIC_OFFERING' as const;
export const UI_CONFIRMED_IS_TRADING = 'UI_CONFIRMED_IS_TRADING' as const;
export const TRADE_CONFIRMATION_RESET = 'TRADE_CONFIRMATION_RESET' as const;
export const TRADE_CONFIRMATION_INIT_BACK_TO_BACK = 'TRADE_CONFIRMATION_INIT_BACK_TO_BACK' as const;
export const TRADE_CONFIRMATION_SET_BACK_TO_BACK_FIELD_VALUE =
  'TRADE_CONFIRMATION_SET_BACK_TO_BACK_FIELD_VALUE' as const;

export const TRADE_CONFIRMATION_SET_BACKED_NOTIONAL_UNIT = 'TRADE_CONFIRMATION_SET_BACKED_NOTIONAL_UNIT' as const;
